import { render } from "./FilterModalSave.vue?vue&type=template&id=b9cc64e4&scoped=true"
import script from "./FilterModalSave.vue?vue&type=script&lang=js"
export * from "./FilterModalSave.vue?vue&type=script&lang=js"

import "./FilterModalSave.vue?vue&type=style&index=0&id=b9cc64e4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9cc64e4"]])

export default __exports__